// extracted by mini-css-extract-plugin
export default {"aboutWrapper":"css_aboutWrapper__K7JEJ","dev_page_content":"css_dev_page_content__yClD-"};